import { render } from "./LogoBox.vue?vue&type=template&id=0243b580&scoped=true"
import script from "./LogoBox.vue?vue&type=script&lang=js"
export * from "./LogoBox.vue?vue&type=script&lang=js"

import "./LogoBox.vue?vue&type=style&index=0&id=0243b580&scoped=true&lang=css"

import exportComponent from "/data0/www.sxsmdx.cn/src/ui/src-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0243b580"]])

export default __exports__